/* eslint-disable no-bitwise */
import React, { Component } from 'react';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { orderBy, isEmpty } from 'lodash';
import numeral from 'numeral';
import {
  personalInformation,
  applicantAction,
  fatcaCrsAction,
  authAction,
  catalogueAction,
} from 'shared/store/actions';
import { isMobileSafari, isIOS } from 'react-device-detect';

import selectors from 'shared/store/selectors';
import {
  PaddedContainer,
  FormElementContainer,
  Label,
  SimpleSelectBox,
  SelectBox,
  Input,
  Notes,
  Modal,
  Options,
  DateInput,
} from 'components';
import { SmartCard } from 'popups';
import {
  FORM_KEYS,
  CLIENT_CLASSIFICATION,
  TYPE_OF_INVESTMENT,
  QUALIFIED_TYPE_OF_INVESTMENT,
  ASSET_ALLOCATIONS,
  OCCUPATIONS,
} from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';
import validation from 'shared/validations';
import utils from 'shared/helpers/utils';
import apiRequest from 'shared/services/api';

class ClientDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isModalWarning: false,
      modalTitle: '',
      modalContent: null,
      isConfirmModalOpen: false,
      isSmartCardOpen: false,
      isInvestedAmountTyping: false,
    };
    // this.timeoutId = undefined;
  }

  // componentDidMount() {
  //   const { mobile, registeredPhoneNumber, onUpdateClientDetails } = this.props;
  //   if (!mobile || mobile === '') onUpdateClientDetails(personalInformation.updateClientDetails(FORM_KEYS.CLIENT_DETAILS.MOBILE, registeredPhoneNumber));
  // }

  componentDidMount() {
    const {
      productCode,
      assetAllocations, // NON DISCRETIONARY ACCT
      investmentStrategies, // DISCRETIONARY ACCT
      // product, // MUTUAL FUND,
      onUpdateClientDetails,
    } = this.props;

    if (!isEmpty(productCode) && !isEmpty(assetAllocations)) {
      onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.CLIENT_CLASSIFICATION,
        CLIENT_CLASSIFICATION.QUALIFIED,
      );
      onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT,
        QUALIFIED_TYPE_OF_INVESTMENT.NON_DISCRETIONARY,
      );
    }
    if (!isEmpty(productCode) && !isEmpty(investmentStrategies)) {
      onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.CLIENT_CLASSIFICATION,
        CLIENT_CLASSIFICATION.QUALIFIED,
      );
      onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT,
        QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY,
      );
    }
    // if (!isEmpty(productCode) && !isEmpty(product)) onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT, QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS);
  }

  saveInvestedUnitAmount = async () => {
    const { product, investedAmount, onUpdateClientDetails } = this.props;
    // const FORSA_ID = 'NWM00033';
    // const ISLAMIC_ID = 'NWM00017';
    // if (product === FORSA_ID || product === ISLAMIC_ID) {
    //   this.props.onSaveApplicant().then(() => {
    //     this.props.onGetApplicantDetails();
    //     this.setState({ isInvestedAmountTyping: false });
    //   });
    // }

    /** @note refactored to call api to calculate and save res to client details */
    // this.props.onSaveApplicant().then(() => {
    //   this.props.onGetApplicantDetails();
    //   this.setState({ isInvestedAmountTyping: false });
    // });
    try {
      if (investedAmount) {
        const res = await apiRequest.getCalculateInvestAmount(
          product,
          investedAmount,
        );
        if (res) {
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.EN_FUND_NAME,
            res.enFundName,
          );
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.ARABIC_FUND_NAME,
            res.arabicFundName,
          );
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.INVESTED_UNIT_TO_AMOUNT,
            res.bufferedInvestmentAmount,
          );
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.BUFFERED_INVESTMENT_UNITS,
            res.bufferedInvestmentUnits,
          );
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.INVESTMENT_UNIT_TYPE,
            res.investmentUnitType,
          );
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.INVESTMENT_UNITS,
            res.investmentUnits,
          );
          onUpdateClientDetails(
            FORM_KEYS.CLIENT_DETAILS.PRODUCT_BANK_DETAILS,
            res.productBankDetails,
          );
          onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.AOA, res.aoa);
          this.props.onSaveApplicant().then(() => {
            this.setState({ isInvestedAmountTyping: false });
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  getModalTitle = (id) => {
    switch (id) {
      case 'classification':
        return 'info.clientClassification.title';
      case 'mobile':
        return 'info.mobile.title';
      case 'investedAmount':
        return 'info.investedAmount.title';
      default:
        return 'infoBox';
    }
  };

  getModalContent = (id) => {
    // const { intl: { formatMessage } } = this.props;
    switch (id) {
      case 'classification':
        return (
          <p>
            <FormattedHTMLMessage id="info.clientClassification.desc" />
          </p>
        );
      case 'mobile':
        return (
          <p>
            <FormattedHTMLMessage id="info.mobile.desc" />
          </p>
        );
      case 'investedAmount':
        return (
          <div>
            <p>
              <FormattedHTMLMessage id="info.investedAmount.desc" />
            </p>
            <ul className="list-column">
              {this.props.minInvestAmountData?.length ? (
                <>
                  {this.props.minInvestAmountData.map(item => (
                    <li key={item.id}>
                      <span>{item.name}</span>
                      <span>
                        {item.minimumInitialAmount}
                        &nbsp;
                        {item.currencyLabel}
                      </span>
                    </li>
                  ))}
                </>
              ) : null}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  onHandleInfoClick = (e) => {
    // console.log('info id ', e);
    this.setState({
      isModalOpen: true,
      modalTitle: this.getModalTitle(e),
      modalContent: this.getModalContent(e),
    });
  };

  onElementChange = ({ target }) => {
    const { name, value } = target;
    const {
      productCode,
      clientClassification,
      formOptions: { productOptions },
      clientAge,
    } = this.props;
    const isMutualFund = productOptions
      .map(item => item.id)
      .includes(utils.getStringAfterSpecialChar(productCode, '-'));

    if (clientAge !== '' && clientAge < 21) {
      this.showMinorDateWarning();
    }
    /**
     * Populate Mutual fund option selection
     * if there is product code included in mutual fund options
     */
    if (isMutualFund) {
      if (
        name === FORM_KEYS.CLIENT_DETAILS.CLIENT_CLASSIFICATION
        && (value === CLIENT_CLASSIFICATION.RETAIL
          || clientClassification === CLIENT_CLASSIFICATION.RETAIL)
      ) {
        this.props.onUpdateClientDetails(
          FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT,
          TYPE_OF_INVESTMENT.MUTUAL_FUNDS,
        );
      }
      if (
        name === FORM_KEYS.CLIENT_DETAILS.CLIENT_CLASSIFICATION
        && (value === CLIENT_CLASSIFICATION.QUALIFIED
          || clientClassification === CLIENT_CLASSIFICATION.QUALIFIED)
      ) {
        this.props.onUpdateClientDetails(
          FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT,
          QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS,
        );
      }
      // FORCE TO USE PRODUCT CODE FROM E-CATALOGUE
      // this.props.onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.PRODUCT, utils.getStringAfterSpecialChar(productCode, '-'));
    }

    /** Clear Type of Investment everytime there is a change in classification */
    // if (name === FORM_KEYS.CLIENT_DETAILS.CLIENT_CLASSIFICATION && !isMutualFund) this.props.onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT, '');

    /** Clear sub options for every type of investment change */
    if (name === FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT) {
      this.props.onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.ASSET_ALLOCATIONS,
        '',
      );
      this.props.onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.INVESTMENT_STRATEGY,
        [],
      );
      this.props.onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.PRODUCT, '');
      this.props.onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.INVESTED_AMOUNT,
        '',
      );
    }

    // Clear invested amount if changing product
    if (name === FORM_KEYS.CLIENT_DETAILS.PRODUCT) {
      this.props.onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.INVESTED_AMOUNT,
        '',
      );
    }

    /** if user selects imarkaz portfolio with no refCode, show the confirmation popup */
    if (
      (value === TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO
        || value === ASSET_ALLOCATIONS.IMARKAZ_PORTFOLIO)
      && !this.props.refCode
    ) {
      this.setState({ isConfirmModalOpen: true });
    }

    /** update client details */
    this.props.onUpdateClientDetails(name, value);

    if (name === FORM_KEYS.CLIENT_DETAILS.INVESTED_AMOUNT) {
      this.setState({ isInvestedAmountTyping: true });
    }
  };

  /** Closing function for confirmation popup */
  onCloseConfirmation = () => {
    this.props.onUpdateClientDetails(
      FORM_KEYS.CLIENT_DETAILS.ASSET_ALLOCATIONS,
      '',
    );
    this.props.onUpdateClientDetails(
      FORM_KEYS.CLIENT_DETAILS.TYPE_OF_INVESTMENT,
      '',
    );
    this.setState({ isConfirmModalOpen: false });
  };

  /** Confirm function for Confirm popup that shows if there is no refCode & use selected imarkaz portfolio */
  onConfirm = () => {
    const { onLogout } = this.props;
    onLogout().then(() => {
      /** have to add this condition for iOS redirection to work */
      if (isIOS || isMobileSafari) {
        window.location.assign(process.env.REACT_APP_MAIN_WRAPPER);
      } else {
        window.open(process.env.REACT_APP_MAIN_WRAPPER, '_self');
      }
    });
    this.setState({ isConfirmModalOpen: false });
  };

  onDateChange = (name, value) => {
    this.props.onUpdateClientDetails(name, value);
  };

  showMinorDateWarning = () => {
    // #174 if the date is minor
    this.setState({
      isModalOpen: true,
      isModalWarning: true,
      modalTitle: '',
      modalContent: (
        <div
          style={{
            textAlign:
              this.props.appLanguage.locale === 'EN' ? 'left' : 'right',
          }}
        >
          {/* <span>
          {this.props.intl.formatMessage({ id: "clientDetails.dob.minor" })}
        </span> */}
          <FormattedHTMLMessage id="clientDetails.dob.minor.v2" />
        </div>
      ),
    });
  };

  onHandleSelect = (name, value) => {
    const {
 onUpdateClientDetails, onUpdateCountryTax, civilId, clientAge 
} =      this.props;
    if (clientAge !== '' && clientAge < 21) {
      this.showMinorDateWarning();
    }
    if (name && value) onUpdateClientDetails(name, value);

    /** if nationality is Kuwaiti, populate country tax jurisdiction */
    if (value === 'Kuwaiti') {
      onUpdateCountryTax(0, 'countryJurisdiction', 'Kuwait');
      onUpdateCountryTax(0, 'isTin', 'Yes');
      onUpdateCountryTax(0, 'tin', civilId);
    }

    /** clear these fields if minor or housewife */
    if (
      name === FORM_KEYS.CLIENT_DETAILS.OCCUPATION
      && (value === OCCUPATIONS.MINOR || value === OCCUPATIONS.HOUSE_WIFE)
    ) {
      onUpdateClientDetails(
        FORM_KEYS.CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME,
        '',
      );
      onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.POSITION, '');
      onUpdateClientDetails(FORM_KEYS.CLIENT_DETAILS.OFFICE_ADDRESS, '');
    }
  };
  // handleIsChecked = (e, sameValue) => !!(e.target.value === sameValue);

  onHandleUpdateInvestorOptions = ({ target }) => {
    const { id } = target;
    this.props.onUpdateQualifiedInvestorOptions(id);
  };

  /** on Saving multiple selections for InvestmentStategy */
  onInvesmentStategyChange = ({ target: { id } }) => {
    this.props.onUpdateInvestmentStrategies(id);
  };

  /** Render Child Options */
  getChildOption = (
    childData,
    name,
    defaultValue,
    label,
    onChangeFunc,
    optionType = 'radio',
    isTranslate,
    withInfo = false,
  ) => (
    <FormElementContainer>
      <Label label={this.props.intl.formatMessage({ id: label })} />

      <Options
        isChildOptionList
        isMultpleElements
        type={optionType}
        hasContainer={false}
        name={name}
        optionList={childData}
        onCheckMarkChange={onChangeFunc} // this.onElementChange
        defaultValue={defaultValue}
        isSubmitClicked
        isTranslate={isTranslate}
        withInfo={withInfo}
        onWithInfoClick={(e) => {
          this.setState({ isSmartCardOpen: true });
          this.props.onSelectedProduct(e);
        }}
      />
    </FormElementContainer>
  );

  /** Populate Mutual Fund Subscription options (for Retail) */
  createChildForInvestmentOptions = () => {
    const {
      product,
      formOptions: { productOptions, typeOfInvestmentOptions },
      imarkazRefCode,
    } = this.props;
    let typeOfInvestmentOptionsCloned = JSON.parse(
      JSON.stringify(typeOfInvestmentOptions),
    );
    const { CLIENT_DETAILS } = FORM_KEYS;
    typeOfInvestmentOptionsCloned =      !imarkazRefCode || imarkazRefCode === null
        ? typeOfInvestmentOptionsCloned.filter(
          item => item.id !== 'NW-MAR-TOI-MAR',
        )
        : typeOfInvestmentOptionsCloned;

    const typeOfInvestmentOptionsMutualFund =      typeOfInvestmentOptionsCloned.find(
        p => p.id === TYPE_OF_INVESTMENT.MUTUAL_FUNDS,
      );
    typeOfInvestmentOptionsMutualFund.child = this.getChildOption(
      orderBy(productOptions, 'label', 'ASC'),
      CLIENT_DETAILS.PRODUCT,
      product && product,
      'clientDetails.forWhichMutual',
      this.onElementChange,
      'radio',
      false,
      true,
    );
    return typeOfInvestmentOptionsCloned;
  };

  /** Populate Mutual Fund Subscription options (for Qualified) */
  handleQualifiedTypeOfInvestmentOptions = () => {
    const {
      product, // mutualFundQualified,
      assetAllocations,
      investmentStrategies,
      formOptions: {
        productOptions,
        assetAllocationOptions,
        investmentStrategyOptions,
        qualifiedTypeOfInvestmentOptions,
      },
      imarkazRefCode,
    } = this.props;
    const { CLIENT_DETAILS } = FORM_KEYS;
    // const nonDiscretionaryData = assetAllocationOptions.filter(item => item.id !== 'NW-MAR-CLA-AA-MAR');
    const nonDiscretionaryData = !imarkazRefCode
      ? assetAllocationOptions.filter(item => item.id !== 'NW-MAR-CLA-AA-MAR')
      : assetAllocationOptions;

    const subOptionMap = {};
    subOptionMap[QUALIFIED_TYPE_OF_INVESTMENT.DISCRETIONARY] = {
      data: investmentStrategyOptions,
      name: CLIENT_DETAILS.INVESTMENT_STRATEGY,
      value: investmentStrategies,
      label: 'clientDetails.forWhichInvestmentStrategy',
      onChange: this.onInvesmentStategyChange,
      type: 'checkbox',
      isTranslate: true,
      withInfo: false,
    };
    subOptionMap[QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS] = {
      data: orderBy(productOptions, 'label', 'ASC'),
      name: CLIENT_DETAILS.PRODUCT,
      value: product,
      label: 'clientDetails.forWhichMutual',
      onChange: this.onElementChange,
      type: 'radio',
      isTranslate: false,
      withInfo: true,
    };
    subOptionMap[QUALIFIED_TYPE_OF_INVESTMENT.NON_DISCRETIONARY] = {
      data: nonDiscretionaryData,
      name: CLIENT_DETAILS.ASSET_ALLOCATIONS,
      value: assetAllocations,
      label: 'clientDetails.forWhichAssetAllocation',
      onChange: this.onElementChange,
      type: 'radio',
      isTranslate: true,
      withInfo: false,
    };

    const qualifiedTypeOfInvestmentOptionsCloned = JSON.parse(
      JSON.stringify(qualifiedTypeOfInvestmentOptions),
    );

    qualifiedTypeOfInvestmentOptionsCloned.forEach((p) => {
      const element = subOptionMap[p.id];
      if (element) {
        p.child = this.getChildOption(
          element.data,
          element.name,
          element.value,
          element.label,
          element.onChange,
          element.type,
          element.isTranslate,
          element.withInfo,
        );
      }
    });
    return qualifiedTypeOfInvestmentOptionsCloned;
  };

  render() {
    const {
      intl,
      clientClassification,
      qualifiedInvestor,
      typeOfInvestment,
      nationality,
      dateOfBirth,
      countryOfBirth,
      occupation,
      countryOfResidence,
      homeAddress,
      emailAddress,
      mobile,
      employerBusinessName,
      position,
      officeAddress,
      investUnitToAmount,
      investedAmount,
      product,
      investmentStrategies,
      assetAllocations,
      productMinInvestAmountData,
      otherNationalityPassport,
      educationLevel,
      otherEducationLevel,
      formOptions: {
        classificationOptions,
        qualifiedOptions,
        occupation: occupationOption,
        educationLevel: educationLevelOptions,
      },
      isSubmitClicked,
      selectedProductCard,
    } = this.props;
    const { CLIENT_DETAILS } = FORM_KEYS;
    const { countries, nationalities } = arrOptions;
    const {
 modalTitle, modalContent, isModalWarning, isInvestedAmountTyping 
} =      this.state;

    const elementValidation = {
      [CLIENT_DETAILS.CLIENT_CLASSIFICATION]: {
        isValid: validation
          .clientDetailSchema(
            intl,
            CLIENT_DETAILS.CLIENT_CLASSIFICATION,
            occupation,
          )
          .isValidSync({ clientClassification }),
        errorMessage: validation.getErrorMessages(
          { clientClassification },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.CLIENT_CLASSIFICATION,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.QUALIFIED_INVESTOR]: {
        isValid: validation
          .qualifiedInvestorSchema(intl, clientClassification)
          .isValidSync({ qualifiedInvestorOptions: qualifiedInvestor }),
        errorMessage: validation.getErrorMessages(
          { qualifiedInvestorOptions: qualifiedInvestor },
          validation.qualifiedInvestorSchema(intl, clientClassification),
        ),
      },
      [CLIENT_DETAILS.TYPE_OF_INVESTMENT]: {
        isValid: validation
          .typeOfInvestmentSchema(
            intl,
            clientClassification,
            product,
            investmentStrategies,
            assetAllocations,
          )
          .isValidSync({ typeOfInvestment }),
        errorMessage: validation.getErrorMessages(
          { typeOfInvestment },
          validation.typeOfInvestmentSchema(
            intl,
            clientClassification,
            product,
            investmentStrategies,
            assetAllocations,
          ),
        ),
      },
      [CLIENT_DETAILS.INVESTED_AMOUNT]: {
        isValid: validation
          .investedAmountSchema(
            intl,
            typeOfInvestment,
            productMinInvestAmountData,
          )
          .isValidSync({ investedAmount }),
        errorMessage: validation.getErrorMessages(
          { investedAmount },
          validation.investedAmountSchema(
            intl,
            typeOfInvestment,
            productMinInvestAmountData,
          ),
        ),
      },
      [CLIENT_DETAILS.NATIONALITY]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.NATIONALITY, occupation)
          .isValidSync({ nationality }),
        errorMessage: validation.getErrorMessages(
          { nationality },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.NATIONALITY,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.DATE_OF_BIRTH]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.DATE_OF_BIRTH, occupation)
          .isValidSync({ dateOfBirth }),
        errorMessage: validation.getErrorMessages(
          { dateOfBirth },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.DATE_OF_BIRTH,
            occupation,
          ),
        ),
      },
      // [CLIENT_DETAILS.CITY_OF_BIRTH]: {
      //   isValid: validation.clientDetailSchema(intl, CLIENT_DETAILS.CITY_OF_BIRTH).isValidSync({ cityOfBirth }),
      //   errorMessage: validation.getErrorMessages({ cityOfBirth }, validation.clientDetailSchema(intl, CLIENT_DETAILS.CITY_OF_BIRTH)),
      // },
      [CLIENT_DETAILS.COUNTRY_OF_BIRTH]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.COUNTRY_OF_BIRTH, occupation)
          .isValidSync({ countryOfBirth }),
        errorMessage: validation.getErrorMessages(
          { countryOfBirth },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.COUNTRY_OF_BIRTH,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.OCCUPATION]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.OCCUPATION, occupation)
          .isValidSync({ occupation }),
        errorMessage: validation.getErrorMessages(
          { occupation },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.OCCUPATION,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.COUNTRY_OF_RESIDENCE]: {
        isValid: validation
          .clientDetailSchema(
            intl,
            CLIENT_DETAILS.COUNTRY_OF_RESIDENCE,
            occupation,
          )
          .isValidSync({ countryOfResidence }),
        errorMessage: validation.getErrorMessages(
          { countryOfResidence },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.COUNTRY_OF_RESIDENCE,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.HOME_ADDRESS]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.HOME_ADDRESS, occupation)
          .isValidSync({ homeAddress }),
        errorMessage: validation.getErrorMessages(
          { homeAddress },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.HOME_ADDRESS,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.EMAIL_ADDRESS]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.EMAIL_ADDRESS, occupation)
          .isValidSync({ emailAddress }),
        errorMessage: validation.getErrorMessages(
          { emailAddress },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.EMAIL_ADDRESS,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME]: {
        isValid: validation
          .clientDetailSchema(
            intl,
            CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME,
            occupation,
          )
          .isValidSync({ employerBusinessName }),
        errorMessage: validation.getErrorMessages(
          { employerBusinessName },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.POSITION]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.POSITION, occupation)
          .isValidSync({ position }),
        errorMessage: validation.getErrorMessages(
          { position },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.POSITION,
            occupation,
          ),
        ),
      },
      [CLIENT_DETAILS.OFFICE_ADDRESS]: {
        isValid: validation
          .clientDetailSchema(intl, CLIENT_DETAILS.OFFICE_ADDRESS, occupation)
          .isValidSync({ officeAddress }),
        errorMessage: validation.getErrorMessages(
          { officeAddress },
          validation.clientDetailSchema(
            intl,
            CLIENT_DETAILS.OFFICE_ADDRESS,
            occupation,
          ),
        ),
      },
    };
    const investmentOptionsModified = this.createChildForInvestmentOptions();
    const qualifiedTypeOfInvestmentOptionsModifed =      this.handleQualifiedTypeOfInvestmentOptions();

    return (
      <PaddedContainer isRtl={this.props.appLanguage.locale === 'AR'}>
        <FormElementContainer>
          <Label
            label={intl.formatMessage({ id: 'clientDetails.classification' })}
            id="classification"
            withInfo
            onWithInfoClick={e => this.onHandleInfoClick(e)}
          />
          <Options
            isMultpleElements
            type="radio"
            hasContainer
            name={CLIENT_DETAILS.CLIENT_CLASSIFICATION}
            optionList={classificationOptions}
            onCheckMarkChange={this.onElementChange}
            defaultValue={clientClassification}
            isValid={
              elementValidation[CLIENT_DETAILS.CLIENT_CLASSIFICATION].isValid
            }
            errorMessage={
              elementValidation[CLIENT_DETAILS.CLIENT_CLASSIFICATION]
                .errorMessage
            }
            isSubmitClicked={isSubmitClicked}
          />
        </FormElementContainer>

        {/* IF CLIENT CLASSIFICATION IS RETAIL */}
        {clientClassification === CLIENT_CLASSIFICATION.RETAIL && (
          <>
            <FormElementContainer>
              <Label
                label={intl.formatMessage({
                  id: 'clientDetails.classification.typeOfInvestment',
                })}
                withLink
                linkLabel={intl.formatMessage({ id: 'openECatalogue' })}
                linkUrl={process.env.REACT_APP_CATALOGUE_URL}
              />
              <Options
                type="radio"
                hasContainer
                name={CLIENT_DETAILS.TYPE_OF_INVESTMENT}
                optionList={investmentOptionsModified}
                onCheckMarkChange={this.onElementChange}
                defaultValue={typeOfInvestment}
                isValid={
                  elementValidation[CLIENT_DETAILS.TYPE_OF_INVESTMENT].isValid
                }
                errorMessage={
                  elementValidation[CLIENT_DETAILS.TYPE_OF_INVESTMENT]
                    .errorMessage
                }
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            <Notes
              msg={(
                <div>
                  <p>
                    <strong>
                      {intl.formatMessage({ id: "info.mutualFundsOnly.title" })}
                    </strong>
                    <br />
                    <FormattedMessage id="info.mutualFundsOnly.desc" />
                  </p>
                  {/* <p>
                    <strong>{intl.formatMessage({ id: 'info.iMarkazPortfolio.title' })}</strong>
                    <br />
                    <FormattedMessage id="info.iMarkazPortfolio.desc" />
                  </p> */}
                </div>
              )}
            />

            {/* IF TYPE OF INVESTMENT IS MUTUAL FUNDS ONLY (FOR RETAIL) */}
            {typeOfInvestment === TYPE_OF_INVESTMENT.MUTUAL_FUNDS && (
              <div className="container-2Cols">
                <FormElementContainer>
                  {/* <Label label={`${intl.formatMessage({ id: 'clientDetails.investedAmount' })} (${productMinInvestAmountData?.currencyLabel})`} id="investedAmount" withInfo onWithInfoClick={e => this.onHandleInfoClick(e)} /> */}
                  <Label
                    label={`${intl.formatMessage({ id: 'clientDetails.investedAmount' })} (${productMinInvestAmountData?.currencyLabel})`}
                    id="investedAmount"
                  />
                  <Input
                    isCurrency
                    placeholder={`${intl.formatMessage({ id: 'clientDetails.investedAmountPlaceHolder' })}`}
                    name={CLIENT_DETAILS.INVESTED_AMOUNT}
                    onInputChange={this.onElementChange}
                    value={investedAmount}
                    isValid={
                      elementValidation[CLIENT_DETAILS.INVESTED_AMOUNT].isValid
                    }
                    errorMessage={
                      elementValidation[CLIENT_DETAILS.INVESTED_AMOUNT]
                        .errorMessage
                    }
                    isSubmitClicked={isSubmitClicked}
                    disabled={product.length === 0}
                    onBlur={this.saveInvestedUnitAmount}
                  />
                </FormElementContainer>
                {productMinInvestAmountData?.currencyLabel === 'Units'
                && elementValidation[CLIENT_DETAILS.INVESTED_AMOUNT].isValid
                && investUnitToAmount
                && !isInvestedAmountTyping ? (
                  <FormElementContainer>
                    <div className="container-2Cols__amount">
                      <FormattedHTMLMessage
                        id="investAmt.KWD"
                        values={{
                          amount: numeral(investUnitToAmount).format('0,0'),
                        }}
                      />
                    </div>
                  </FormElementContainer>
                ) : null}
              </div>
            )}
          </>
        )}

        {/* IF CLIENT CLASSIFICATION IS QUALIFIED */}
        {clientClassification === CLIENT_CLASSIFICATION.QUALIFIED && (
          <>
            <FormElementContainer>
              <Label
                label={intl.formatMessage({
                  id: 'clientDetails.classification.qualified.question',
                })}
              />
              <Options
                type="checkbox"
                name={CLIENT_DETAILS.QUALIFIED_INVESTOR}
                optionList={qualifiedOptions}
                onCheckMarkChange={this.onHandleUpdateInvestorOptions}
                defaultValue={qualifiedInvestor}
                isValid={
                  elementValidation[CLIENT_DETAILS.QUALIFIED_INVESTOR].isValid
                }
                errorMessage={
                  elementValidation[CLIENT_DETAILS.QUALIFIED_INVESTOR]
                    .errorMessage
                }
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>
            {qualifiedInvestor && qualifiedInvestor.length !== 0 && (
              <>
                <FormElementContainer>
                  <Label
                    label={intl.formatMessage({
                      id: 'clientDetails.classification.typeOfInvestmentServices',
                    })}
                  />
                  <Options
                    type="radio"
                    hasContainer
                    name={CLIENT_DETAILS.TYPE_OF_INVESTMENT}
                    optionList={qualifiedTypeOfInvestmentOptionsModifed}
                    onCheckMarkChange={this.onElementChange}
                    defaultValue={typeOfInvestment}
                    isValid={
                      elementValidation[CLIENT_DETAILS.TYPE_OF_INVESTMENT]
                        .isValid
                    }
                    errorMessage={
                      elementValidation[CLIENT_DETAILS.TYPE_OF_INVESTMENT]
                        .errorMessage
                    }
                    isSubmitClicked={isSubmitClicked}
                  />
                </FormElementContainer>

                <Notes
                  msg={(
                    <div>
                      <p>
                        <strong>
                          {intl.formatMessage({
                            id: "info.mutualFundsOnly.title",
                          })}
                        </strong>
                        <br />
                        <FormattedMessage id="info.mutualFundsOnly.desc" />
                      </p>
                      <p>
                        <strong>
                          {intl.formatMessage({
                            id: "info.discretionaryAcct.title",
                          })}
                        </strong>
                        <br />
                        <FormattedMessage id="info.discretionaryAcct.desc" />
                      </p>
                      <p>
                        <strong>
                          {intl.formatMessage({
                            id: "info.nonDiscretionaryAcct.title",
                          })}
                        </strong>
                        <br />
                        <FormattedMessage id="info.nonDiscretionaryAcct.desc" />
                      </p>
                      <p>
                        <strong>
                          {intl.formatMessage({
                            id: "info.custodyAccount.title",
                          })}
                        </strong>
                        <br />
                        <FormattedMessage id="info.custodyAccount.desc" />
                      </p>
                    </div>
                  )}
                />

                {typeOfInvestment
                  === QUALIFIED_TYPE_OF_INVESTMENT.MUTUAL_FUNDS && (
                  <div className="container-2Cols">
                    <FormElementContainer>
                      {/* <Label label={`${intl.formatMessage({ id: 'clientDetails.investedAmount' })} (${productMinInvestAmountData?.currencyLabel})`} id="investedAmount" withInfo onWithInfoClick={e => this.onHandleInfoClick(e)} /> */}
                      <Label
                        label={`${intl.formatMessage({ id: 'clientDetails.investedAmount' })} (${productMinInvestAmountData?.currencyLabel})`}
                      />
                      <Input
                        isCurrency
                        placeholder={`${intl.formatMessage({ id: 'clientDetails.investedAmountPlaceHolder' })}`}
                        name={CLIENT_DETAILS.INVESTED_AMOUNT}
                        onInputChange={this.onElementChange}
                        value={investedAmount}
                        isValid={
                          elementValidation[CLIENT_DETAILS.INVESTED_AMOUNT]
                            .isValid
                        }
                        errorMessage={
                          elementValidation[CLIENT_DETAILS.INVESTED_AMOUNT]
                            .errorMessage
                        }
                        isSubmitClicked={isSubmitClicked}
                        disabled={product.length === 0}
                        onBlur={this.saveInvestedUnitAmount}
                      />
                    </FormElementContainer>
                    {productMinInvestAmountData?.currencyLabel === 'Units'
                    && elementValidation[CLIENT_DETAILS.INVESTED_AMOUNT].isValid
                    && investUnitToAmount
                    && !isInvestedAmountTyping ? (
                      <FormElementContainer>
                        <div className="container-2Cols__amount">
                          <FormattedHTMLMessage
                            id="investAmt.KWD"
                            values={{
                              amount: numeral(investUnitToAmount).format('0,0'),
                            }}
                          />
                        </div>
                      </FormElementContainer>
                    ) : null}
                  </div>
                )}
              </>
            )}
          </>
        )}

        {clientClassification && (
          <FormElementContainer>
            <SimpleSelectBox
              label={intl.formatMessage({ id: 'clientDetails.nationality' })}
              placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientDetails.nationality' }).toLowerCase()}`}
              dataList={nationalities}
              name={CLIENT_DETAILS.NATIONALITY}
              onSelect={this.onHandleSelect}
              defaultValue={nationality}
              isSearchInputDisabled={false}
              isValid={elementValidation[CLIENT_DETAILS.NATIONALITY].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.NATIONALITY].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
            {/* <Input
            label={intl.formatMessage({ id: 'clientDetails.nationality' })}
            placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.nationality' }).toLowerCase()}`}
            name={CLIENT_DETAILS.NATIONALITY}
            onInputChange={this.onElementChange}
            value={nationality}
          /> */}
            <DateInput
              label={intl.formatMessage({ id: 'clientDetails.dob' })}
              name={CLIENT_DETAILS.DATE_OF_BIRTH}
              onInputChange={this.onDateChange}
              value={dateOfBirth}
              minor={21}
              minorWarning={this.showMinorDateWarning}
              isValid={elementValidation[CLIENT_DETAILS.DATE_OF_BIRTH].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.DATE_OF_BIRTH].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />

            {/* @note: add new field for this */}
            <Input
              label={intl.formatMessage({
                id: 'clientDetails.otherNationalityPassport',
              })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.otherNationalityPassport' }).toLowerCase()}`}
              name={CLIENT_DETAILS.OTHER_NATIONALITY_PASSPORT}
              onInputChange={this.onElementChange}
              value={otherNationalityPassport}
              // isValid={elementValidation[CLIENT_DETAILS.OTHER_NATIONALITY_PASSPORT].isValid}
              // errorMessage={elementValidation[CLIENT_DETAILS.OTHER_NATIONALITY_PASSPORT].errorMessage}
              isSubmitClicked={isSubmitClicked}
            />

            <SimpleSelectBox
              label={intl.formatMessage({ id: 'clientDetails.cob' })}
              placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientDetails.cob' }).toLowerCase()}`}
              dataList={countries}
              name={CLIENT_DETAILS.COUNTRY_OF_BIRTH}
              onSelect={this.onHandleSelect}
              defaultValue={countryOfBirth}
              isSearchInputDisabled={false}
              isValid={
                elementValidation[CLIENT_DETAILS.COUNTRY_OF_BIRTH].isValid
              }
              errorMessage={
                elementValidation[CLIENT_DETAILS.COUNTRY_OF_BIRTH].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
            <SimpleSelectBox
              label={intl.formatMessage({
                id: 'clientDetails.countryOfResidence',
              })}
              placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientDetails.countryOfResidence' }).toLowerCase()}`}
              dataList={countries}
              name={CLIENT_DETAILS.COUNTRY_OF_RESIDENCE}
              onSelect={this.onHandleSelect}
              defaultValue={countryOfResidence}
              isSearchInputDisabled={false}
              isValid={
                elementValidation[CLIENT_DETAILS.COUNTRY_OF_RESIDENCE].isValid
              }
              errorMessage={
                elementValidation[CLIENT_DETAILS.COUNTRY_OF_RESIDENCE]
                  .errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
            <Input
              label={intl.formatMessage({ id: 'clientDetails.homeAddress' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.homeAddress' }).toLowerCase()}`}
              name={CLIENT_DETAILS.HOME_ADDRESS}
              onInputChange={this.onElementChange}
              value={homeAddress}
              isValid={elementValidation[CLIENT_DETAILS.HOME_ADDRESS].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.HOME_ADDRESS].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />
            <Input
              type="email"
              label={intl.formatMessage({ id: 'clientDetails.emailAddress' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.emailAddress' }).toLowerCase()}`}
              name={CLIENT_DETAILS.EMAIL_ADDRESS}
              onInputChange={this.onElementChange}
              value={emailAddress}
              isValid={elementValidation[CLIENT_DETAILS.EMAIL_ADDRESS].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.EMAIL_ADDRESS].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />

            <FormElementContainer>
              <Label
                label={intl.formatMessage({ id: 'clientDetails.mobileNumber' })}
                id="mobile"
                withInfo
                onWithInfoClick={e => this.onHandleInfoClick(e)}
              />
              <Input
                type="tel"
                // label={intl.formatMessage({ id: 'clientDetails.mobileNumber' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.mobileNumber' }).toLowerCase()}`}
                name={CLIENT_DETAILS.MOBILE}
                onInputChange={this.onElementChange}
                value={mobile}
                disabled
                isSubmitClicked={isSubmitClicked}
              />
            </FormElementContainer>

            {/* <Input
              label={intl.formatMessage({ id: 'clientDetails.occupationPrincipalActivity' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.occupationPrincipalActivity' }).toLowerCase()}`}
              name={CLIENT_DETAILS.OCCUPATION}
              onInputChange={this.onElementChange}
              value={occupation}
              isValid={elementValidation[CLIENT_DETAILS.OCCUPATION].isValid}
              errorMessage={elementValidation[CLIENT_DETAILS.OCCUPATION].errorMessage}
              isSubmitClicked={isSubmitClicked}
            /> */}
            <SelectBox
              label={intl.formatMessage({
                id: 'clientDetails.occupationPrincipalActivity',
              })}
              placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientDetails.occupationPrincipalActivity' }).toLowerCase()}`}
              hasContainer
              dataList={occupationOption.filter(
                item => item.id !== 'NW-MAR-OCC-OT',
              )}
              name={CLIENT_DETAILS.OCCUPATION}
              onSelect={this.onHandleSelect}
              defaultValue={occupation}
              isValid={elementValidation[CLIENT_DETAILS.OCCUPATION].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.OCCUPATION].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
            />

            <Input
              label={intl.formatMessage({ id: 'clientDetails.employer' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.employer' }).toLowerCase()}`}
              name={CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME}
              onInputChange={this.onElementChange}
              value={employerBusinessName}
              isValid={
                elementValidation[CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME].isValid
              }
              errorMessage={
                elementValidation[CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME]
                  .errorMessage
              }
              isSubmitClicked={isSubmitClicked}
              disabled={
                occupation === OCCUPATIONS.MINOR
                || occupation === OCCUPATIONS.HOUSE_WIFE
              }
            />
            <Input
              label={intl.formatMessage({ id: 'clientDetails.position' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.position' }).toLowerCase()}`}
              name={CLIENT_DETAILS.POSITION}
              onInputChange={this.onElementChange}
              value={position}
              isValid={elementValidation[CLIENT_DETAILS.POSITION].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.POSITION].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
              disabled={
                occupation === OCCUPATIONS.MINOR
                || occupation === OCCUPATIONS.HOUSE_WIFE
              }
            />
            <Input
              label={intl.formatMessage({ id: 'clientDetails.officeAddress' })}
              placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.officeAddress' }).toLowerCase()}`}
              name={CLIENT_DETAILS.OFFICE_ADDRESS}
              onInputChange={this.onElementChange}
              value={officeAddress}
              isValid={elementValidation[CLIENT_DETAILS.OFFICE_ADDRESS].isValid}
              errorMessage={
                elementValidation[CLIENT_DETAILS.OFFICE_ADDRESS].errorMessage
              }
              isSubmitClicked={isSubmitClicked}
              disabled={
                occupation === OCCUPATIONS.MINOR
                || occupation === OCCUPATIONS.HOUSE_WIFE
              }
            />

            {/* @Note: add EDUCATION LEVEL field */}
            <SelectBox
              label={intl.formatMessage({ id: 'clientDetails.educLevel' })}
              placeholder={`${intl.formatMessage({ id: 'select' })} ${intl.formatMessage({ id: 'clientDetails.educLevel' }).toLowerCase()}`}
              dataList={educationLevelOptions}
              name={CLIENT_DETAILS.EDUCATION_LEVEL}
              onSelect={this.onHandleSelect}
              defaultValue={educationLevel}
              // isValid={elementValidation[CLIENT_DETAILS.EDUCATION_LEVEL].isValid}
              // errorMessage={elementValidation[CLIENT_DETAILS.EDUCATION_LEVEL].errorMessage}
              isSubmitClicked={isSubmitClicked}
            />

            {educationLevel === 'NW-EDU-OTH' ? (
              <Input
                label={intl.formatMessage({ id: 'bankDetails.others' })}
                placeholder={`${intl.formatMessage({ id: 'enter' })} ${intl.formatMessage({ id: 'clientDetails.otherEducLevel' }).toLowerCase()}`}
                name={CLIENT_DETAILS.OTHER_EDUCATION_LEVEL}
                onInputChange={this.onElementChange}
                value={otherEducationLevel}
                // isValid={elementValidation[CLIENT_DETAILS.OTHER_EDUCATION_LEVEL].isValid}
                // errorMessage={elementValidation[CLIENT_DETAILS.OTHER_EDUCATION_LEVEL].errorMessage}
                isSubmitClicked={isSubmitClicked}
              />
            ) : null}
          </FormElementContainer>
        )}

        {selectedProductCard && (
          <SmartCard
            showModal={this.state.isSmartCardOpen}
            onClose={() => this.setState({ isSmartCardOpen: false })}
            intl={intl}
          />
        )}

        {/* Information popup */}
        <Modal
          withPadding
          isWarning={isModalWarning}
          showModal={this.state.isModalOpen}
          title={modalTitle ? intl.formatMessage({ id: modalTitle }) : ''}
          onClose={() => this.setState({ isModalOpen: false, isModalWarning: false })
          }
        >
          {/* <span>Content here</span> */}
          {modalContent}
        </Modal>

        {/* Confirmation popup */}
        <Modal
          withPadding
          isConfirm
          showModal={this.state.isConfirmModalOpen}
          title={intl.formatMessage({ id: 'modal.idUpload.title' })}
          onClose={() => this.onCloseConfirmation()}
          onConfirm={this.onConfirm}
        >
          {/* <p><FormattedHTMLMessage id="warning.msg1" /></p> */}
          <p>
            <FormattedHTMLMessage id="warning.msg2" />
          </p>
          <p>
            <FormattedHTMLMessage id="warning.msg3" />
          </p>
          <p>
            <FormattedHTMLMessage id="warning.msg4" />
          </p>
        </Modal>
      </PaddedContainer>
    );
  }
}

const mapStateToProps = state => ({
  formOptions: selectors.getFormOptions(state),
  clientClassification: selectors.getClientClassification(state),
  mutualFundQualified: selectors.getMutualFundQualified(state),
  investmentStrategies: selectors.getInvestmentStrategy(state),
  assetAllocations: selectors.getAssetAllocation(state),
  investedAmount: selectors.getInvestedAmount(state),
  investUnitToAmount: selectors.getInvestedUnitToAmount(state),

  qualifiedInvestor: selectors.getQualifiedInvestor(state),
  typeOfInvestment: selectors.getTypeOfInvestment(state),
  product: selectors.getProduct(state),
  productMinInvestAmountData: selectors.getProductMinInvestAmountData(state),
  nationality: selectors.getNationality(state),
  dateOfBirth: selectors.getFormatedDateOfBirth(state),
  // cityOfBirth: selectors.getCityOfBirth(state),
  countryOfBirth: selectors.getCountryOfBirth(state),
  occupation: selectors.getOccupation(state),
  homeAddress: selectors.getHomeAddress(state),
  countryOfResidence: selectors.getCountryOfResidence(state),
  emailAddress: selectors.getEmailAddress(state),
  mobile: selectors.getMobile(state),
  employerBusinessName: selectors.getEmployer(state),
  position: selectors.getPosition(state),
  officeAddress: selectors.getOfficeAddress(state),
  isSubmitClicked: selectors.getIsFormSubmitted(state),
  civilId: selectors.getCivilId(state),
  otherNationalityPassport: selectors.getOtherCivilIdOrPassport(state),
  educationLevel: selectors.getEducationLevel(state),
  otherEducationLevel: selectors.getOtherEducationLevel(state),

  registeredPhoneNumber: state.authReducer.phoneNumber,
  refCode: selectors.getRefCode(state),
  productCode: selectors.getProductCode(state),

  selectedProductCard: state.catalogueReducer.selected,
  minInvestAmountData: selectors.getMinInvestAmountData(state),
  imarkazRefCode: state.applicantRootReducer.applicantReducer.imarkazRefCode,
  appLanguage: selectors.getLanguage(state),
  clientAge: selectors.getAge(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateClientDetails: (name, value) => {
    dispatch(personalInformation.updateClientDetails(name, value));
  },
  onUpdateQualifiedInvestorOptions: selectedId => dispatch(personalInformation.updateQualifiedInvestorOptions(selectedId)),
  onUpdateInvestmentStrategies: selectedId => dispatch(personalInformation.updateInvestmentStrategies(selectedId)),
  onTestCreateApplicant: phoneNumber => dispatch(applicantAction.createApplicant(phoneNumber)),
  onUpdateCountryTax: (index, key, value) => dispatch(fatcaCrsAction.updateCountryTax(index, key, value)),
  onLogout: () => dispatch(authAction.logout()),

  onSelectedProduct: id => dispatch(catalogueAction.selectedProduct(id)),
  onSaveApplicant: isGenerate => dispatch(applicantAction.updateApplicant(isGenerate)),
  onGetApplicantDetails: () => dispatch(applicantAction.getApplicantDetails()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ClientDetails));
